const dpr        = (window.devicePixelRatio !== undefined) ? window.devicePixelRatio : 1;
const TRADUCTION = {};
const CONFIG     = {};
CONFIG.IE11      = !!navigator.userAgent.match(/Trident.*rv[ :]*11\./);
CONFIG.EDGE      = !!navigator.userAgent.match(/Edge/);
((CONFIG.IE11 === true) && document.querySelector("html").classList.add("internetexplorer"));
((CONFIG.EDGE === true) && document.querySelector("html").classList.add("edge"));
const SITE_CLASS_BODY_CHANGE = false;
CONFIG.IsIpad                = navigator.userAgent.match(/iPad/i) != null;
CONFIG.ISTABLET              = document.querySelector("html").classList.contains('device_tablet');
CONFIG.ISMOBILE              = document.querySelector("html").classList.contains('device_smartphone');
CONFIG.ISDESKTO              = document.querySelector("html").classList.contains('device_bureau');
CONFIG.IsRetina        = dpr > 1;
CONFIG.INTRO_TIMESCALE = 1;
CONFIG.INTRO_DONE      = false;
CONFIG.VERSION         = document.querySelector("html").classList.contains("version_smartphone") ? "version_smartphone" : "version_bureau";
const VERSION_BUREAU   = (CONFIG.VERSION === "version_bureau");
const BUREAU_ONLY      = (VERSION_BUREAU && CONFIG.ISDESKTO);
const VERSION_SMARTP   = (CONFIG.VERSION === "version_smartphone");
const EVENTS           = {};
EVENTS.MOUSEWHEEL      = (/Firefox/i.test(navigator.userAgent)) ? "DOMMouseScroll" : "mousewheel";
EVENTS.MOUSEOUT        = "mouseout";
EVENTS.MOUSELEAVE      = "mouseleave";
EVENTS.MOUSEENTER      = "mouseenter";
EVENTS.MOUSEMOVE       = "mousemove";
EVENTS.MOUSECLICK      = "click";
EVENTS.TOUCHSTART      = "touchstart";
EVENTS.RESIZE          = "resize";
EVENTS.KEYUP           = "keyup";
EVENTS.KEYDOWN         = "keydown";
EVENTS.EXTRACLICK      = ((CONFIG.ISTABLET) === true) ? "click" : "click";
window.DEBUG           = false;

const broadCaster      = {
	GMAPLOADED        : new signals.Signal(),
	GALELOADED        : new signals.Signal(),
	INTROMENU         : new signals.Signal(),
	INTROPAGE         : new signals.Signal(),
	BACKGROUND_HIDE   : new signals.Signal(),
	BACKGROUND_SHOW   : new signals.Signal(),
	MENU_HOVER        : new signals.Signal(),
	MENU_LEAVE        : new signals.Signal(),
	MENU_CLICK        : new signals.Signal(),
	PAGE_INTRO_CONTENT: new signals.Signal(),
	SITE_LOADURL      : new signals.Signal(),
};

function getDelayIntro() {
	return 0;
}

if (typeof WebKitCSSMatrix == "undefined") {
	window.WebKitCSSMatrix = window.DOMMatrix;
}
;

function getTranslateX(elt) {
	let style  = window.getComputedStyle(elt);
	let matrix = new WebKitCSSMatrix(style.webkitTransform);
	return matrix.m41;
}

function setDocSize() {
	var w             = window,
		d             = document,
		e             = d.documentElement,
		g             = d.getElementsByTagName('body')[0],
		x             = w.innerWidth || e.clientWidth || g.clientWidth,
		y             = w.innerHeight || e.clientHeight || g.clientHeight;
	window.windowSize = {width: x, height: y};
}

function getDocSize() {
	return windowSize;
};

function setMousePosition(e) {
	if (e) {
		window.mousePosition = {x: e.clientX, y: e.clientY};
	} else {
		window.mousePosition = {x: 0, y: 0, rationFull: {x: 0, y: 0}};
	}
	window.mousePosition.rationFull   = {x: window.mousePosition.x / windowSize.width, y: window.mousePosition.y / windowSize.height};
	window.mousePosition.rationMiddle = {x: (window.mousePosition.x / (windowSize.width * .5)) - 1, y: (window.mousePosition.y / (windowSize.height * .5)) - 1};
}

function handleOrientation(e) {
	try {
		window.mousePosition.rationFull             = {x: 2 * (e.gamma / 90), y: 5 * (-.5 - (e.beta - 90) / 90)};
		window.mousePosition.rationMiddle           = window.mousePosition.rationFull;
		document.querySelector("._debug").innerHTML = window.mousePosition.rationFull.x;
	} catch (e) {
	}
}

window.addEventListener("resize", setDocSize, supportsPassive);
document.addEventListener("mousemove", setMousePosition, supportsPassive);

// window.addEventListener("deviceorientation"	, handleOrientation, supportsPassive);
function getNodeindex(elm) {
	return [...elm.parentNode.children].indexOf(elm)
}

function removeNode(elm) {
	elm.parentNode.removeChild(elm);
}

setDocSize();
setMousePosition();

function shuffle(array) {
	let counter = array.length;
	// While there are elements in the array
	while (counter > 0) {
		// Pick a random index
		let index = Math.floor(Math.random() * counter);
		// Decrease counter by 1
		counter--;
		// And swap the last element with it
		let temp       = array[counter];
		array[counter] = array[index];
		array[index]   = temp;
	}
	return array;
}

function guid() {
	function s4() {
		return Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);
	}
	
	return s4() + '-' + s4();
}

function debounce(func, wait = 100) {
	let timeout;
	return function (...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => {func.apply(this, args);}, wait);
	};
}

NodeList.prototype.map    = Array.prototype.map;
NodeList.prototype.filter = Array.prototype.filter;
Number.prototype.between  = function (a, b) {
	let min = Math.min(a, b), max = Math.max(a, b);
	return this > min && this < max;
};
let scrollDiv             = document.createElement("div");
scrollDiv.className       = "scrollbar-measure";
scrollDiv.style.width     = "100px";
scrollDiv.style.height    = "100px";
scrollDiv.style.overflow  = "scroll";
scrollDiv.style.position  = "absolute";
scrollDiv.style.top       = "-9999px";
document.body.appendChild(scrollDiv);
CONFIG.scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
document.body.removeChild(scrollDiv);
let e             = [
	"\n%c creation VLW https://www.vinium.com/  %c %c %c %c\n\n",
	"color: #white; background: #5A3F36; padding:5px 0;",
	"margin-left:5px;background: #002395; padding:0;",
	"background: #ffffff; padding:0;",
	"background: #ED2939; padding:0;",
	"background: transparent; padding:0;"
];
var clientConsole = window.clientConsole = console;
clientConsole.log.apply(clientConsole, e);
let __ConsoleClearShortcut = new Date().getTime();
window.addEventListener("keydown", (e) => {
	let _now = new Date().getTime();
	if (e.key === "ArrowRight") {
		(_now - __ConsoleClearShortcut <= 200) && console.clear();
		__ConsoleClearShortcut = _now;
	}
});
